"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VoucherLabel = exports.VoucherForm = exports.InputWrapper = exports.ExclamationMark = exports.ErrorWrapper = exports.CellInput = exports.CellButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const VoucherForm = exports.VoucherForm = (0, _mui.styled)('form')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        minWidth: 113,
        padding: theme.spacing(4, 3),
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
            minWidth: 413,
            padding: theme.spacing(4, 6, 6, 6),
            borderRadius: theme.spacing(2)
        }
    };
});
const VoucherLabel = exports.VoucherLabel = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        whiteSpace: 'nowrap',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2)
    };
});
const CellInput = exports.CellInput = (0, _mui.styled)('div')(()=>({
        display: 'flex'
    }));
const InputWrapper = exports.InputWrapper = (0, _mui.styled)('div')(()=>({
        position: 'relative',
        width: '100%'
    }));
const ErrorWrapper = exports.ErrorWrapper = (0, _mui.styled)('div')(()=>({
        position: 'absolute',
        right: '0',
        top: '0',
        transform: 'translate(0, 10px)'
    }));
const ExclamationMark = exports.ExclamationMark = (0, _mui.styled)(_icons.PriorityHigh)((param)=>{
    let { theme } = param;
    return {
        fontSize: '1.5rem',
        color: theme.palette.error.main,
        border: '1px solid',
        borderRadius: '50%',
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.error.contrastText,
        '&:hover': {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        }
    };
});
const CellButton = exports.CellButton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignSelf: 'flex-end',
        margin: theme.spacing(0, 0, 0, 4)
    };
});
